import { HorseType } from '@/utils/horseType'
import { DocumentType } from '@/utils/documentTypes'

export type DocumentRuleType = 'COMPULSORY' | 'COMPULSORY_IF_FG_CONTRACT' | 'COMPULSORY_IF_TROT_AND_CONTRACT' | 'COMPULSORY_IF_COVERED' | 'OPTIONAL_IF_FEMALE' | 'OPTIONAL_IF_MALE' | 'OPTIONAL'

export const documentsRule: Partial<Record<HorseType, Partial<Record<DocumentType, DocumentRuleType>>>> = {
  'CAE': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'COMPULSORY',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'COMPULSORY',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'METRITE': 'OPTIONAL_IF_FEMALE',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'EXPORT_SANITARY_CERTIFICATE_JPN_SELLER': 'OPTIONAL',
    'EXPORT_SANITARY_CERTIFICATE_USA_SELLER': 'OPTIONAL',
    'REPRODUCTION': 'OPTIONAL_IF_FEMALE',
    'CONTRAT_FG_SELLER': 'COMPULSORY_IF_FG_CONTRACT',
    'DOSSIER_VETERINAIRE': 'OPTIONAL',
    'TESTICLES_CERTIFICATE': 'OPTIONAL_IF_MALE',
  },
  'MARE': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'COMPULSORY',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'COMPULSORY',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'METRITE': 'COMPULSORY',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'EXPORT_SANITARY_CERTIFICATE_JPN_SELLER': 'OPTIONAL',
    'EXPORT_SANITARY_CERTIFICATE_USA_SELLER': 'OPTIONAL',
    'REPRODUCTION': 'OPTIONAL',
    'CERTIFICAT_SAILLIE_SELLER': 'COMPULSORY_IF_COVERED',
  },
  'STORE2': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'COMPULSORY',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'OPTIONAL',
    'METRITE': 'OPTIONAL_IF_FEMALE',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'EXPORT_SANITARY_CERTIFICATE_JPN_SELLER': 'OPTIONAL',
    'EXPORT_SANITARY_CERTIFICATE_USA_SELLER': 'OPTIONAL',
    'DOSSIER_VETERINAIRE': 'OPTIONAL',
    'TESTICLES_CERTIFICATE': 'OPTIONAL_IF_MALE',
  },
  'YEAR2': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'COMPULSORY',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'OPTIONAL',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'EXPORT_SANITARY_CERTIFICATE_JPN_SELLER': 'OPTIONAL',
    'EXPORT_SANITARY_CERTIFICATE_USA_SELLER': 'OPTIONAL',
    'DOSSIER_VETERINAIRE': 'OPTIONAL',
    'TESTICLES_CERTIFICATE': 'OPTIONAL_IF_MALE',
  },
  'FOAL': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'COMPULSORY',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'OPTIONAL',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'EXPORT_SANITARY_CERTIFICATE_JPN_SELLER': 'OPTIONAL',
    'EXPORT_SANITARY_CERTIFICATE_USA_SELLER': 'OPTIONAL',
    'DOSSIER_VETERINAIRE': 'OPTIONAL',
    'TESTICLES_CERTIFICATE': 'OPTIONAL_IF_MALE',
  },
  'STALLION': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'COMPULSORY',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'COMPULSORY',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'METRITE': 'COMPULSORY',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'EXPORT_SANITARY_CERTIFICATE_JPN_SELLER': 'OPTIONAL',
    'EXPORT_SANITARY_CERTIFICATE_USA_SELLER': 'OPTIONAL',
    'TESTICLES_CERTIFICATE': 'OPTIONAL_IF_MALE',
    'CONTRAT_FG_SELLER': 'COMPULSORY_IF_TROT_AND_CONTRACT',
  },
  'STORE3': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'COMPULSORY',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'OPTIONAL',
    'METRITE': 'OPTIONAL_IF_FEMALE',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'EXPORT_SANITARY_CERTIFICATE_JPN_SELLER': 'OPTIONAL',
    'EXPORT_SANITARY_CERTIFICATE_USA_SELLER': 'OPTIONAL',
    'DOSSIER_VETERINAIRE': 'OPTIONAL',
    'TESTICLES_CERTIFICATE': 'OPTIONAL_IF_MALE',
  },
  'MAIDEN': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'COMPULSORY',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'CONTRAT_FG_SELLER': 'COMPULSORY_IF_FG_CONTRACT',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'COMPULSORY',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'METRITE': 'COMPULSORY',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'EXPORT_SANITARY_CERTIFICATE_JPN_SELLER': 'OPTIONAL',
    'EXPORT_SANITARY_CERTIFICATE_USA_SELLER': 'OPTIONAL',
    'REPRODUCTION': 'OPTIONAL',
    'DOSSIER_VETERINAIRE': 'OPTIONAL',
  },
  'YEARLING': {
    'COPIE_DOCUMENT_ACCOMPAGNEMENT': 'COMPULSORY',
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CHEVAL_ETRANGER': 'OPTIONAL',
    'COGGINS': 'COMPULSORY',
    'ARTERITE': 'OPTIONAL',
    'PIROPLASMOSE_SELLER': 'OPTIONAL',
    'CERTIFICAT_SANITAIRE_ARQANA': 'COMPULSORY',
    'EXPORT_SANITARY_CERTIFICATE_JPN_SELLER': 'OPTIONAL',
    'EXPORT_SANITARY_CERTIFICATE_USA_SELLER': 'OPTIONAL',
    'DOSSIER_VETERINAIRE': 'OPTIONAL',
    'TESTICLES_CERTIFICATE': 'OPTIONAL_IF_MALE',
  },
  'STALLION_PART': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
    'CONTRAT_FG_SELLER': 'COMPULSORY_IF_TROT_AND_CONTRACT',
  },
  'BREEDING_RIGHT': {
    'TITRE_PROPRIETE_SELLER': 'COMPULSORY',
  },
}
